import EnrolledPatientResultTable from './EnrolledPatientResultTable';

export default EnrolledPatientResultTable;



// WEBPACK FOOTER //
// ./src/views/components/EnrolledPatientResultTable/index.js